<template>
    <TransitionRoot
        appear
        :show="true"
        enter="transform transition duration-500"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transform duration-200 transition ease-in-out"
        leave-from="opacity-100 "
        leave-to="opacity-0 "
        as="template"
    >
        <slot />
    </TransitionRoot>
</template>

<script setup>
import { TransitionRoot } from '@headlessui/vue';

defineProps({
    condition: {
        type: Boolean,
        default: false,
    },
});
</script>
